import { render } from "./the-header.vue?vue&type=template&id=df64c7ae&scoped=true"
import script from "./the-header.vue?vue&type=script&lang=js"
export * from "./the-header.vue?vue&type=script&lang=js"

import "./the-header.vue?vue&type=style&index=0&id=df64c7ae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df64c7ae"]])

export default __exports__